import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import HomePage       from './pages/Home/HomePage';
import CataloguePage from './pages/Catalogue/CataloguePage';
import ProductDetail  from './pages/Product/ProductDetail';
import CartPage       from './pages/Cart/CartPage';
import ContactPage    from './pages/Contact/ContactPage';
import LoginPage      from './pages/Auth/LoginPage';
import RegisterPage   from './pages/Auth/RegisterPage';
import DashboardPage  from './pages/Auth/DashboardPage';
import PrivateRoute   from './components/PrivateRoute/PrivateRoute';
import AdminRoute     from './components/AdminRoute/AdminRoute';
import AdminPage      from './pages/Admin/AdminPage';
import './index.css';
import CheckoutPage from './pages/Checkout/CheckoutPage';
import SuiviPage from './pages/Suivi/SuiviPage';
import MentionsLegales from './pages/Legal/MentionsLegales';
import CGV from './pages/Legal/CGV';
import PolitiqueConfidentialite from './pages/Legal/PolitiqueConfidentialite';
import CookieBanner from './components/CookieBanner/CookieBanner';

function NotFound() {
  return (
    <div style={{ paddingTop: 'var(--navbar-h)', textAlign: 'center', padding: '140px 24px', minHeight: '60vh' }}>
      <p style={{ fontFamily: 'var(--font-titre)', fontSize: '4rem', color: 'var(--or)', marginBottom: 8 }}>404</p>
      <p style={{ color: 'var(--gris)', marginBottom: 32 }}>Cette page n'existe pas ou a été déplacée.</p>
      <Link to="/" className="btn-or">Retour à l'accueil</Link>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Navbar />
          <main>
            <Routes>
              <Route path="/"                      element={<HomePage />} />
              <Route path="/catalogue"             element={<CataloguePage />} />
              <Route path="/catalogue/:categorie"  element={<CataloguePage />} />
              <Route path="/produit/:id"           element={<ProductDetail />} />
              <Route path="/panier"                element={<CartPage />} />
              <Route path="/contact"               element={<ContactPage />} />
              <Route path="/connexion"             element={<LoginPage />} />
              <Route path="/inscription"           element={<RegisterPage />} />
              <Route path="/mon-compte" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
              {/* Le tunnel de commande n'est plus une route protégée : une
                  visiteuse peut commander sans compte. La page propose
                  elle-même le choix entre connexion, inscription et
                  commande invitée. */}
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/suivi"    element={<SuiviPage />} />
              <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/cgv" element={<CGV />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}